/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdCommonModule} from '@angular/material/core';
import {MdToolbar, MdToolbarRow} from './toolbar';
export class MdToolbarModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule],
  exports: [MdToolbar, MdToolbarRow, MdCommonModule],
  declarations: [MdToolbar, MdToolbarRow],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdToolbarModule_tsickle_Closure_declarations() {
/** @type {?} */
MdToolbarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdToolbarModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
